export enum LOADING_STATUS {
    NONE = 'NONE',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
}
